// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>29</span>&nbsp;&nbsp;All of these look to you&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;to give them their food in due season.<br> </p> </div></div>";
// Exports
module.exports = code;